module.exports = __webpack_public_path__ + "static/img/11.2a41551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/11.png
// module id = ChW3
// module chunks = 0